import React, { forwardRef, useState, useEffect, useMemo, useCallback } from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import message from "components/CustomMessage";
import { FieldTypes } from "utils/formUtils";
import { uniqBy } from 'lodash';
import GenericMappingForm from "../GenericMappingForm";

const CheckmarxSCAMappingForm = forwardRef(function CheckmarxSCAMappingForm ({disableProjectFields = false, ...props}, ref){
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { projectId, projectName } = props.record;
      const projectIdArray = projectId.split(',');
      const projectNameArray = projectName.split(',');
      return projectIdArray.map((id, index) => ({id, name: projectNameArray[index]}))
    }
    return [];
  });
  const [loading, setLoading] = useState(true);

    useEffect(() => {
        const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
        promise.then((response) => {
          const { projects } = response;
          setProjects(prev => uniqBy([...prev,...projects], 'id'));
        }).catch((err)=>{
          message.error('Problem fetching projects')
        }).finally(() => setLoading(false));
        
        return cancel;
    }, [props.loginConfigId, props.toolName]);

    const getExtraFieldsData = (config) => {
        const { projectId } = config;
    
        const data = projects.reduce((acc,cv) =>{
          const { id, name } = cv;
          if(projectId.includes(id)){
            acc.id.push(id);
            acc.name.push(name);
          }
          return acc;
        },{id:[],name:[]})
    
        return ({
          projectId:data.id.join(),
          projectName:data.name.join()
        });
    }

    const extraFields = useMemo(() => ([
        {
          name: 'projectId',
          colSpan: '12',
          loading: loading,
          type: FieldTypes.MULTI_SELECT,
          disabled: disableProjectFields,
          props:{
            autoFocus:!disableProjectFields
          },
          label: 'Checkmarx SCA Project',
          options: projects,
          required: true,
        }
    ]), [projects, loading,disableProjectFields]);

    const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return {  projectId:config.projectId.split(',') };
    }, []);

    return (
    <GenericMappingForm
        ref={ref}
        projects={projects}
        getExtraFieldsData={getExtraFieldsData}
        extraFields={extraFields}
        parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
        {...props}
    />
    )
});

export default CheckmarxSCAMappingForm;